import {
  AppBar,
  AppBarSection,
  AppBarSpacer,
} from '@progress/kendo-react-layout';
import { isCanada } from 'app/common/websiteCountry';
import some from 'lodash/some';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { NotificationsTopRight } from '../NotificationsTopRight';
import { ProfileTopRight } from '../ProfileTopRight';
import { LayoutContext } from '../ReactContexts/layoutContext';
import { LanguageSwitcher } from 'app/components/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context';
import { Logo } from 'app/components/logos';

export function KubotaAppBar() {
  const { classNames, setClassNames, removeSpecificClass } =
    React.useContext(LayoutContext);
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();

  const animateMobileNav = () => {
    setClassNames('mobile-nav-animating');
    window.setTimeout(() => {
      removeSpecificClass('mobile-nav-animating');
    }, 600);
  };

  const handleClick = () => {
    animateMobileNav();
    if (!some(classNames, cls => cls.class === 'mobile-nav-shown')) {
      setClassNames('mobile-nav-shown');
    } else {
      removeSpecificClass('mobile-nav-shown');
    }
  };

  return (
    <AppBar className={`${isCanada ? 'website-CA' : ''} appbar-nav`}>
      <AppBarSection className="appbar-nav-toggle-section">
        <span className="mobile-menu-toggle" onClick={handleClick}>
          <svg
            id="ic_menu_hamburger"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
          >
            <rect id="Box" width="32" height="32" fill="none" />
            <line
              id="Line"
              x2="20"
              transform="translate(6 8.5)"
              fill="none"
              stroke="#1a1a1a"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              id="Line-2"
              data-name="Line"
              x2="20"
              transform="translate(6 23.5)"
              fill="none"
              stroke="#1a1a1a"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              id="Line-3"
              data-name="Line"
              x2="20"
              transform="translate(6 16)"
              fill="none"
              stroke="#1a1a1a"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </svg>
        </span>
      </AppBarSection>
      <AppBarSection className="appbar-logo-section">
        <Link to={isAuthenticated ? '/equipment' : '/login'}>
          <Logo />
        </Link>
      </AppBarSection>
      <AppBarSpacer className="appbar-spacer" />

      {isAuthenticated && (
        <>
          <AppBarSection>
            <NotificationsTopRight />
          </AppBarSection>

          <AppBarSection>
            <ProfileTopRight />
          </AppBarSection>
        </>
      )}

      {!isAuthenticated && (
        <>
          <AppBarSection>
            <Link className="sign-in-link" to="/login">
              {t('sign_in')}
            </Link>
          </AppBarSection>

          <AppBarSection>
            <LanguageSwitcher className="app-bar__language-switcher" />
          </AppBarSection>
        </>
      )}
    </AppBar>
  );
}
